const status = {
  CREATED: 1,
  OPEN: 2,
  CANCELED: 3,
  ACCEPTANCE_PENDING: 4,
  EVALUATION_PENDING: 5,
  EVALUATED: 6,
  EXPIRED: -1
}

export default status
